export default {
    'modal.qd': 'Confirm',
    'modal.qx': 'Cancel',
    'modal.cg': 'success',
    'modal.sb': 'defeated'
}
